<template lang="html">

  <section class="avantage">
    <div id="content">

        <div class="section" id="Homeimg">
            <div class="headtitle">
                <div class="text-center">
                    <h1>Touchez plus de personne, <br> avec SkanTicket</h1>
                    <a href="https://billeterie.skanticket.com/inscription" class="shadow btn btn-lg btn-yellow  btn-chevron">Creer une billeterie</a>
                </div>
            </div>
        </div>

        <div class="section" id="billeterieTime">
            <div class="container">
                <div class="row">
                    <div class="col-md-7">
                        <h4>Billeterie prete <br/> moins de 5 minutes</h4>
                        <p>Configurez aisément un module de billetterie ou d'inscription en ligne, et donnez la possibilité à vos participants de s'inscrire et de payer facilement en ligne. Puis, vendez vos billets ! via notre interface.</p>
                    </div>
                </div>         
            </div>
        </div>

        <div class="section" id="followData">
            <div class="container">
                <div class="row justify-content-end">
                    <div class="col-md-7 text-right">
                        <h4> Suivez les donnees <br/> de pres </h4>
                        <p>SkanTicket fournit un tableau de bord de suivi en temps réel de vos ventes directement depuis votre interface Organisateur en ligne. Pour chaque vente, SkanTicket vous envoie la notification par email..</p>
                    </div>
                </div>         
            </div>
        </div>
        <div class="section" id="ourstrength">
                <div class="container">
                    <div class="row">
                        <div class="col-md-4 text-center">
                            <div class="strength">
                                <img src="../assets/img/process_payment.png">
                                <h5 class="process">Vendez partout</h5>
                                <p>Vendez partout en exploitant tous les canaux gérés par SkanTicket (Applications mobiles, USSD, Mini site web ...)</p>
                            </div>
                        </div>
                        <div class="col-md-4 text-center">
                                <div class="strength">
                                    <img src="../assets/img/integration_social.png">
                                    <h5 class="process">Gérez les réseaux sociaux</h5>
                                    <p>Touchez plus de clients en permettant à vos clients de partager votre événement sur les reseaux sociaux.</p>
                                </div>
                        </div>
                        <div class="col-md-4 text-center">
                            <div class="strength">
                                <img src="../assets/img/suivi_vente.png">
                                <h5 class="process">Controlez les entrées</h5>
                                <p>Configurez votre smartphone en terminal de contrôle en installant notre application mobile android gratuite SkanAccess.</p>
                            </div>
                        </div>
                    </div>
                </div>
        </div>

        <div class="section text-center" id="services">
            <div class="container">
                <h3>Services d’accompagnement</h3>
                <hr>
                <p>SkanTicket offre des services supplementaires et sur mésure pour votre événement pour y apporter encore plus de valeur ajoutée</p>
    
                <div class="row justify-content-md-center ">
                    <div class="col-md-4 text-center saccomp">
                        <img src="../assets/img/location.jpg" class="rounded-circle">
                        <h5>Location d'equipement</h5>
                        <p>SkanTicket met en location des terminaux de controle d'accès</p>
    
                    </div>
                    <div class="col-md-4 text-center saccomp">
                        
                        <img src="../assets/img/team.jpg" class="rounded-circle">
                        <h5>Personnel logistique</h5>
                        <p>SkanTicket vous fournit du personnel pour le controle des entrées</p>
                 
                    </div>
                </div>

            </div>
        </div>

        <div class="section text-center" id="testimony">
            <div class="container">
                <h3>Temoignages</h3>
                <hr>
                <p>Ils nous font confiance.</p>
                <div class="row  ">
                    <div class="col-md-4 text-center saccomp">
                            
                        <img src="../assets/img/tedx_logo.png" class="rounded-circle">
                        <!--<p class="Message">Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br/> Aliquam non dictum nisi. Fusce eget nullam.</p>-->
                        <h5 class="Name">Andeka Oulé</h5>
                        <p class="jobTitle">Commissaire général</p>
                    </div>
                    <div class="col-md-4 text-center saccomp">
                        <img src="../assets/img/majestic_logo.jpg" class="rounded-circle">
                        <!--<p class="Message">Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br/> Aliquam non dictum nisi. Fusce eget nullam.</p>-->
                        <h5 class="Name">Nancy Aka</h5>
                        <p class="jobTitle">Directrice marketing</p>
        
                    </div>
                    <div class="col-md-4 text-center saccomp">
                            
                        <img src="../assets/img/afriqueconsciente_logo.png" class="rounded-circle">
                        <!--<p class="Message">Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br/> Aliquam non dictum nisi. Fusce eget nullam.</p>-->
                        <h5 class="Name">Gilles Atayi</h5>
                        <p class="jobTitle">Commissaire général</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <pied-creer-billetterie/>
  </section>

</template>

<script lang="js">
  import PiedCreerBilletterie from "@/components/PiedCreerBilletterie"
  export default  {
    name: 'avantage',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    },
    components: {
      PiedCreerBilletterie
    }
}
</script>

<style scoped>
  .section#Homeimg
{
    background-image: url(../assets/img/avantages_bg.jpg);
    height: 39em;
    position: relative;
    overflow-y: hidden;
    padding-top: 0;
    padding-bottom: 0;
    background-size: 100% auto;
    background-position: center center;
}

.headtitle .text-center
{
    color: #ffffff;
    margin-top: 17em;
}

.section#billeterieTime
{
    padding: 13em 0 ;
    background-image: url(../assets/img/quick_start.png), linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(245,245,245,1) 100%);
    background-size: auto 100%;
    background-position: right top ;
    background-repeat: no-repeat;
}

.section#billeterieTime h4, .section#followData h4
{
    color: #2857B1;
    font-size: 2rem;
}

.section#followData
{
    padding: 13em 0 ;
    background-image: url(../assets/img/data_analysis.png),linear-gradient(90deg, rgba(247,232,199,1) 0%, rgba(255,255,255,1) 25%);
    background-position: left top ;
    background-repeat: no-repeat;
    background-size: auto 100% ;
}

.section#ourstrength
{
    padding: 8em 0;
    
}

.section#ourstrength img
{
    height: 8em;
    padding-bottom: 2em;
}

.col-md-4 >.process
{
    color:#32517F;
}

.section#services  hr
{
    border: solid;
    width: 6em;
    color: #32517F;
}

.saccomp > img 
{
    height: 9em;
    width: 9em;
    object-fit: cover;
    margin-top: 2em;
    margin-bottom: 2em;
}

.section#services
{
    background-color: #F7F7F7;
    padding: 5em 0;
}

.section#testimony hr
{
    border: solid;
    width: 6em;
    color: #32517F;
}
.section#testimony 
{
    padding: 5em 0;

}

.section#testimony .jobTitle
{
    color: var(--sk-darkblue);
}

.section#testimony .Name
{
    font-weight: bold;
}

.rounded-circle{
    border: 1px solid #dadde1;
}

.headtitle h1{
    font-size: 2.5rem;
}
</style>
